module.exports = __webpack_public_path__ + "static/media/membership2026-child.a3d2723d.png";